module.exports = __webpack_public_path__ + "img/Icon-Team Directory.7f0d2f25.svg";